export default __webpack_public_path__ + "static/media/img_marklogic-colorBkg.9edcae39.png";